import React from 'react';
import { Breakpoint } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AlertDialog from '../AlertDialog';

interface InfoDialogProps {
  button?: React.ReactElement;
  dialogContent: React.ReactElement | string;
  maxWidth?: Breakpoint;
}

export default function InfoDialog(props: InfoDialogProps) {
  const { button, dialogContent, maxWidth = 'xs' } = props;
  const infoDialogIcon = <InfoOutlinedIcon style={{ fontSize: '1rem', height: 12, cursor: 'pointer' }} />;
  const buttonDialog = button || infoDialogIcon;
  return (
    <AlertDialog
      dialogContent={dialogContent}
      button={buttonDialog}
      maxWidth={maxWidth}
      hideSubmitButton
      hideLogo
    />
  );
}

InfoDialog.defaultProps = {
  maxWidth: 'xs',
  button: null,
};
